import * as React from "react";
import styled from "styled-components";

import { PublishedRelease } from "../../../../../../../common/types/release/published-release";

import { ReleaseDetailHeader } from "./detail-header";
import { ReleaseDetailSummary } from "./detail-summary/index";
import { DetailContainer } from "../common/detail-container";
import { Release } from "../../../../../../../common/types/release/release";

interface ReleaseDetailContentProps {
  published: PublishedRelease;
  onUpdateField: <T extends keyof Release>(key: T, value: Release[T]) => void;
}

export const ReleaseDetailContent: React.FC<ReleaseDetailContentProps> = (
  props
) => {
  const { release, tracks, subscription, artists } = props.published;

  return (
    <DetailContainer>
      <HeaderContainer>
        <ReleaseDetailHeader subscription={subscription} release={release} artists={artists} />
      </HeaderContainer>
      <ReleaseDetailSummary
        release={release}
        tracks={tracks}
        onUpdateField={props.onUpdateField}
      />
    </DetailContainer>
  );
};

const HeaderContainer = styled.div`
  margin-bottom: 2rem;
`;
